module.exports = __webpack_public_path__ + "img/top1head@2x.ed67a8e1.png";